export const environment = {
    production: false,
    environmentName : 'stg',
    serverUrl : 'https://idr-stg.umgc.edu',
    ssoUrl : 'https://login.windows.net/704ce3d6-a4bf-4e09-8516-d52840c9f7a9/oauth2/v2.0/authorize',
    clientUrl : 'https://crmia-stg.umgc.edu',
    ssoOn : true,
    clientId : 'ac89e45f-fb1a-46d6-9f8a-77caeb69c8c8'
  };
  